/* eslint-disable no-console */
import { AxiosError } from 'axios';
import {
  fetchCheckAuth,
  fetchClusterDb,
  fetchDashboard,
} from 'components/libs/fetch';
import { API_PATHS } from 'constant/api';

import { DATA_SETTING, TABLE_PAGE_INIT, TABLE_PAGE_SIZE } from './constant';

const postAuthLogin = async (header: IHeader) => {
  const api = fetchCheckAuth(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  try {
    const { data } = await api.get(API_PATHS.face_db);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const postSettingDb = async (body: ISettingQuery) => {
  const api = fetchDashboard({ appId: body.appId, appKey: body.appKey });
  try {
    const { data } = await api.post(
      API_PATHS.setting(body.id, body.clusterDbId),
      { username: body.username, roleType: DATA_SETTING.roleType }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getDatabases = async (body: IGetDatabaseQuery) => {
  const api = fetchDashboard({ appId: body.appId, appKey: body.appKey });
  const { ...query } = body;

  const searchQuery: Record<string, string> = {
    'pagination[page]': query.page ?? TABLE_PAGE_INIT,
    'pagination[pageSize]': query.pageSize ?? TABLE_PAGE_SIZE,
  };
  if (query.name) searchQuery['filters[name]'] = query.name;
  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.database(body.id) + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getVisits = async (query: IVisitQuery, header: IHeader) => {
  const api = fetchClusterDb(
    header.appId,
    header.appKey,
    header.dbId,
    header.dbKey
  );

  const searchQuery: Record<string, string> = {};
  if (query.startTime) searchQuery['startTime'] = query.startTime;
  if (query.endTime) searchQuery['endTime'] = query.endTime;
  if (query.referenceId) searchQuery['referenceId'] = query.referenceId;
  const params = new URLSearchParams(searchQuery).toString();

  try {
    const { data } = await api.get(API_PATHS.visit + '?' + params);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export interface ISystemErrorResponse {
  response_message?: string;
  response_code?: string;
}

export type FetchErrorData = AxiosError<ISystemErrorResponse>;

export { getDatabases, getVisits, postAuthLogin, postSettingDb };
